import { useEffect, useState } from "react";
import { fetchProfiles, fetchEvents } from "./api";
import "../../scss/cdp-styles.scss";
import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer } from "recharts";

const Dashboard = () => {
  const [profiles, setProfiles] = useState([]);
  const [liveEvents, setLiveEvents] = useState([]);
  const colors = ["#82ca9d", "#8884d8", "#ffc658", "#ff7300", "#d88484", "#84d8ca"];

  useEffect(() => {
    const loadData = async () => {
      const profilesData = await fetchProfiles(4);
      const eventsData = await fetchEvents(10);
      setProfiles(profilesData.list || []);
      setLiveEvents(eventsData.list || []);
    };
    loadData();
  }, []);

  const eventTypes = {
    'profile-created': 76,
    'session-opened': 76,
    'visit-started': 76,
    'checkout-started': 63,
    'profile-update': 60
  };

  const eventChartData = Object.entries(eventTypes).map(([name, value]) => ({ name, value }));

  return (
    <div className="dashboard-container">
      <div className="dashboard-grid">
        {/* Event Chart */}
        <div className="chart-card">
          <h3>No of events by type</h3>
          <div className="chart-container">
            <ResponsiveContainer width="100%" height={200}>
              <PieChart>
                <Pie 
                  data={eventChartData} 
                  dataKey="value" 
                  nameKey="name" 
                  cx="50%" 
                  cy="50%" 
                  outerRadius={80}
                  innerRadius={60}
                >
                  {eventChartData.map((_, index) => (
                    <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="event-list">
            {Object.entries(eventTypes).map(([name, count]) => (
              <div key={name} className="event-item">
                <span>{name}</span>
                <span>{count}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Online Sessions Card */}
        <div className="sessions-card">
          <h3>Online Sessions</h3>
          <div className="sessions-content">
            <div className="sessions-number">76</div>
            <div className="sessions-subtitle">Calculated from 785 online events</div>
            <div className="time-zones">
              <div className="time-zone-item">
                <span>Asia/Muscat</span>
                <span>26</span>
              </div>
              <div className="time-zone-item">
                <span>Africa/Abidjan</span>
                <span>19</span>
              </div>
              <div className="time-zone-item">
                <span>America/Panama</span>
                <span>18</span>
              </div>
            </div>
          </div>
        </div>

        {/* Live Event Stream */}
        <div className="live-stream-card">
          <h3>Live Event Stream</h3>
          <div className="event-stream">
            {liveEvents.map((event, index) => (
              <div key={index} className="stream-event">
                <div className="event-badge">
                  <span className="event-type">{event.eventType}</span>
                  <span className="event-source">Internal</span>
                  <span className="event-time">~10m</span>
                </div>
                <div className="event-location">{event.source?.location || "Unknown"}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
